import { LegalClientActivityEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';
import { Maybe } from 'types/maybe';

import { CompanyActivityFormType } from '../../forms/companyActivityForm';

export const parseCompanyActivityValue = (
  data: Maybe<LegalClientActivityEntity> | undefined,
  t: TFunc
): CompanyActivityFormType['companyActivity'] => {
  if (!data) {
    return {} as CompanyActivityFormType['companyActivity'];
  }

  return {
    activity: {
      label: t(`client.legal.companyActivity.activity.types.${data.activity}`),
      value: data.activity,
    },
    isLargeEnterprise: yesOrNotOption(t, data.isLargeEnterprise)!,
    isNominalHolder: yesOrNotOption(t, data.isNominalHolder)!,
    requiresNominalHoldingSubaccount: yesOrNotOption(
      t,
      data.requiresNominalHoldingSubaccount
    ),
    otherActivity: data.otherActivity,
  };
};
